/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {MenuEntry} from "@app/models/menu-entry";
import {CommonActions} from "@app/store/common/common.actions";
import {CommonState} from "@app/store/common/common.state";
import {AppMenuService} from "@modules/base/services/app-menu.service";
import {Select, Store} from "@ngxs/store";
import {SaluteHelperV2Service, TrecAuthStoreService, TrecError} from "@trec/api";
import {C3SnackbarStatusService} from "@trec/components/snackbar-status";
import {Observable, Subscription, of} from "rxjs";

@Component({
  selector: "app-home-page",
  templateUrl: "./home-page.component.html",
  styleUrls: ["./home-page.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HomePageComponent implements OnInit, OnDestroy {
  @Select(CommonState.isAuthenticated) isAuthenticated$: Observable<boolean>;
  chat: boolean | null;
  televisita: boolean | null;
  token: string | null;
  navigationEntries: MenuEntry[];
  private readonly subscr = new Subscription();

  constructor(
    private menuService: AppMenuService,
    private store: Store,
    private route: ActivatedRoute,
    private router: Router,
    protected cd: ChangeDetectorRef,
    private authStore: TrecAuthStoreService,
    private saluteHelperV2Service: SaluteHelperV2Service,
    private snackBar: C3SnackbarStatusService
  ) { }

  ngOnInit() {
    // Init menu entries ////////////////////////
    this.subscr.add(
      this.store.select(CommonState.isPhysician).subscribe((isPhysician) => {
        // Load menu entries and make it available for the template
        this.navigationEntries = this.menuService.getMenuList();
        // const questionnaire = localStorage.getItem('questionnaires');

        // console.log('questionnaire', questionnaire);

        // if (questionnaire === "true") {
        //   this.navigationEntries.filter((a) => a.route == "questionnaires")[0].hide = of(false);
        // }

        if (isPhysician) {
          if (localStorage.getItem("configuratoreChat")) {
            this.navigationEntries.filter((a) => a.route == "messages")[0].hide = of(
              !JSON.parse(localStorage.getItem("configuratoreChat")!)
            );
          }
          if (localStorage.getItem("configuratoreTelevisita")) {
            this.navigationEntries.filter((a) => a.route == "video-meeting")[0].hide = of(
              !JSON.parse(localStorage.getItem("configuratoreTelevisita")!)
            );
          }
          /*        if (localStorage.getItem('questionnaires')) {
                     this.navigationEntries.filter((a) => a.route == "questionnaires")[0].hide = of(false);
                   } */
          if (localStorage.getItem("survey") == "true") {
            this.navigationEntries.filter((a) => a.route == "questionnaires")[0].hide = of(false);
          }
          if (localStorage.getItem("configuratoreMultipaziente") == "true" || localStorage.getItem("survey") == "true") {
            this.navigationEntries.filter((a) => a.route == "patient-group")[0].hide = of(false);
          }

          //Enrolment's Requests Patient visibility for MMG
          //console.log("MMG found - showing Enrolment's Requests Patient menu entry");
          if (localStorage.getItem("mmg") == "true") {
            this.navigationEntries.filter((a) => a.route == "enrolment-requests")[0].hide = of(false);
          }
        }

        // Hide doctor-dashboard depending on isPhysician flag (hide when flag is not 'true' (ie: is false or undefined))
        this.navigationEntries.filter((a) => a.route.indexOf("doctor-panel") != -1)[0].hide = of(
          isPhysician !== true
        );
        /*  this.navigationEntries.filter((a) => a.route.indexOf("questionnaire") != -1)[0].hide = of(isPhysician === true); */
        this.cd.markForCheck();
      })
    );

    this.subscr.add(
      this.store.select(CommonState.isDocsAdministrator).subscribe((isDocsAdministrator) => {
        // Hide docs admin button depending on role
        this.navigationEntries.filter(
          (a) => a.route.indexOf("hospital-administration") != -1
        )[0].hide = of(isDocsAdministrator !== true);
        this.cd.markForCheck();
      })
    );

    this.subscr.add(
      this.store.select(CommonState.isChiefMedicalOfficer).subscribe((isChiefMedicalOfficer) => {
        // Hide docs admin button depending on role
        this.navigationEntries.filter(
          (a) => a.route.indexOf("hospital-administration") != -1
        )[0].hide = of(isChiefMedicalOfficer !== true);
        this.cd.markForCheck();
      })
    );

    localStorage.removeItem("filteringPatientCf");

    // Clear selected patient if any
    this.store.dispatch(new CommonActions.SetPatientId({patientId: null}));

    // Richiesta di 7laghi: se nell'url compare il codice fiscale vuol dire che si sta
    // arrivando da whospital, quindi faccio il redirect alla pagina del dettaglio paziente
    const cfPaziente = this.route.snapshot.queryParamMap.get("cfPaziente");
    const idPaziente = this.route.snapshot.queryParamMap.get("idPaziente");
    const appAttiva = this.route.snapshot.queryParamMap.get("appAttiva");
    const sid = this.route.snapshot.queryParamMap.get("SID");
    this.token = localStorage.getItem("3c-token");
    if (cfPaziente) {
      localStorage.setItem("filteringPatientCf", cfPaziente);
      if (idPaziente && appAttiva && appAttiva === "true") {
        this.router.navigateByUrl(
          "doctor-panel/patients/" + idPaziente + "/page/(patient-page:calendar/page)"
        );
      } else if (idPaziente && appAttiva && appAttiva === "false") {
        this.router.navigateByUrl(
          "doctor-panel/patients/" + idPaziente + "/page/(patient-page:app-prescription/page)"
        );
      } else {
        this.router.navigateByUrl("doctor-panel/page?quickFilter=" + cfPaziente);
      }
    }

    if (sid && !this.token) {
      console.log("SID", sid);
      this.saluteHelperV2Service.redirectLogin(sid).subscribe(
        (data: any) => {
          let trecUserId = data.trecUserId;
          this.authStore.saveAuthInfo({token: data.jwt, trecUserId});
          location.reload();
          this.cd.detectChanges();
        },
        (err: any) => {
          this.snackBar.showError({
            error: new TrecError("Errore SSO: " + err.message, ""),
            messagesMap: {
              "": "Il medico non è presente in trec+",
            },
          });
        }
      );
    }
  }

  ngOnDestroy() {
    this.subscr.unsubscribe();
  }
}
